module.exports = __webpack_public_path__ + "f2ffad7756511090a84f6664d9fe69fa.svg";